/*
Copyright (c) 2024, HP Development Company, L.P. All rights reserved.
This software contains confidential and proprietary information of HP.
The user of this software agrees not to disclose, disseminate or copy
such Confidential Information and shall use the software only in accordance
with the terms of the license agreement the user entered into with HP.
*/

import React, { forwardRef } from 'react';
import TBackNavigationButton, {
  BackNavigationButtonAnalytics
} from './BackNavigationButton';
import { BackNavigationButtonProps } from './types';
/**
 * UI Toolkit Back Navigation button component based on Veneer Button
 * @public
 */
const BackNavigationButton = forwardRef<
  HTMLButtonElement,
  BackNavigationButtonProps
>((props, ref) => {
  const { buttonText, onClick, trackId, ...rest } = props;
  if (trackId) {
    return (
      <BackNavigationButtonAnalytics
        trackId={trackId}
        {...rest}
        ref={ref}
        onClick={onClick}
        buttonText={buttonText}
      />
    );
  }
  return (
    <TBackNavigationButton
      {...rest}
      ref={ref}
      onClick={onClick}
      buttonText={buttonText}
    />
  );
});

BackNavigationButton.displayName = 'BackNavigationButton';

export type { BackNavigationButtonProps };
export default BackNavigationButton;
